import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { cls } from '@mssgme/helpers';

import styles from './styles.scss';

const RadioIcon = ({ color = '#007AFF' }) => (
    <svg
        version="1.1"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
    >
        <g fill="none" fillRule="evenodd">
            <g transform="translate(-568 -3567)">
                <g transform="translate(568 3567)">
                    <rect
                        x=".75"
                        y=".75"
                        width="16.5"
                        height="16.5"
                        rx="8.25"
                        stroke={color}
                        strokeWidth="1.5"
                    />
                    <rect className={styles.radioDot} x="3" y="3" width="12" height="12" rx="6" fill={color} />
                </g>
            </g>
        </g>
    </svg>
);

RadioIcon.propTypes = {
    color: PropTypes.string,
};

const RadioGroup = ({ options, value, name, onChange, pane, hasError, ...rest }) =>
    (
        <div {...cls([pane && styles.pane], rest)}>
            {options.map((option, index) => {
                const isSelected = value === option.value;

                return (
                    <div key={name + index} className={classNames(styles.radio, isSelected && styles.active)}>
                        <label>
                            <RadioIcon color={rest.style?.color} />
                            <input type="radio" name={name} value={option.value} checked={isSelected} onChange={onChange} />
                            <span dangerouslySetInnerHTML={{ __html: option.label }} />
                        </label>
                    </div>
                );
            })}
        </div>
    );

RadioGroup.propTypes = {
    value: PropTypes.string,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, value: PropTypes.string })).isRequired,
    onChange: PropTypes.func.isRequired,
    pane: PropTypes.bool,
    hasError: PropTypes.bool,
};

export default RadioGroup;
